import { BUYING_METRICS } from '@skyrise-eng/types';
import { useGetRateCardOptionsQuery } from '@/api';
import { UseRateCardOptions } from '../RateCards.types';
import { useDebounce } from '@/hooks/useDebounce';

export const useRateCardOptions: UseRateCardOptions = ({ channel }) => {
  const debouncedChannelValue = useDebounce(channel);
  const { data: filterOptions } = useGetRateCardOptionsQuery({ showDraft: true });
  const { data: rateCardOptions, isLoading: areRateCardOptionsLoading } = useGetRateCardOptionsQuery({
    ...(debouncedChannelValue && { channel: [debouncedChannelValue] }),
    showDraft: true
  });

  return {
    filterOptions,
    rateCardOptions: { ...rateCardOptions, buyingMetrics: Object.values(BUYING_METRICS) },
    areRateCardOptionsLoading
  };
};
